import React from 'react';
import { Link } from 'react-router-dom';
import { brandLogos } from '../data/brandAssets';
import './BrandLogo.css';

export default function BrandLogo({
  className = '',
  size = 'nav',
  linkTo = '/',
  asLink = true,
  variant = 'theme',
}) {
  const variantClass =
    variant === 'theme' ? '' : `brand-logo--on-${variant}`;

  const logo = (
    <span
      className={`brand-logo brand-logo--${size} ${variantClass} ${!asLink ? className : ''}`.trim()}
    >
      <img
        src={brandLogos.black}
        alt="BeyonDigital"
        className="brand-logo__img brand-logo__img--light"
      />
      <img
        src={brandLogos.green}
        alt="BeyonDigital"
        className="brand-logo__img brand-logo__img--dark"
      />
    </span>
  );

  if (!asLink) {
    return logo;
  }

  return (
    <Link to={linkTo} className={`brand-logo-link brand-logo-link--${size} ${className}`.trim()}>
      {logo}
    </Link>
  );
}
